import { render, staticRenderFns } from "./CreateEditTag.vue?vue&type=template&id=d190574a&"
import script from "./CreateEditTag.vue?vue&type=script&lang=js&"
export * from "./CreateEditTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports